/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID, IdWithOptimisticLock } from '@gh/common-shared-data';
import {
  AbstractRestService,
  arrayOf,
  identity,
  optimisticLockingOf,
  RestSettings,
} from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobStageListItemDto, JobStagesFilterDto } from './job-stage.dto';
import { JobStageListItemMapper } from './job-stage.mapper';

@Injectable()
export class JobStageRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  get(id: ID): Observable<JobStageListItemDto> {
    return this.httpGet(`${this.bp}/job-stage/${id}`, optimisticLockingOf(JobStageListItemMapper));
  }

  create(item: JobStageListItemDto): Observable<JobStageListItemDto> {
    return this.httpPost(
      `${this.bp}/job-stage`,
      item,
      optimisticLockingOf(JobStageListItemMapper),
    );
  }

  findAll(filter: JobStagesFilterDto): Observable<JobStageListItemDto[]> {
    return this.httpGet(
      `${this.bp}/job-stage`,
      filter,
      identity(),
      arrayOf(JobStageListItemMapper));
  }

  undelete(item: JobStageListItemDto): Observable<JobStageListItemDto> {
    return this.httpPut(
      `${this.bp}/job-stage/${item.id}/undelete`,
      void 0,
      optimisticLockingOf(JobStageListItemMapper));
  }

  update(item: JobStageListItemDto): Observable<JobStageListItemDto> {
    return this.httpPut(
      `${this.bp}/job-stage/${item.id}`,
      item,
      optimisticLockingOf(JobStageListItemMapper),
    );
  }

  updateJobStages(order: IdWithOptimisticLock[]): Observable<JobStageListItemDto[]> {
    return this.httpPut(
      `${this.bp}/job-stage/drag`,
      order,
      identity(),
      arrayOf(JobStageListItemMapper),
    );
  }

  deactivateOrDelete(item: JobStageListItemDto): Observable<JobStageListItemDto> {
    return this.httpPut(
      `${this.bp}/job-stage/${item.id}/delete`, void 0, optimisticLockingOf(JobStageListItemMapper));
  }
}
